import { NavLink } from "react-router-dom";
import { KanbanSquare, Users, Car, Receipt, Settings, Wrench, X, LogOut, ShieldCheck } from "lucide-react";
import { useOrders } from "@/lib/OrdersContext";
import { useAuth } from "@/lib/AuthContext";

const NAV = [
  { to: "/", label: "Panel Kanban", icon: KanbanSquare, id: "kanban" },
  { to: "/clientes", label: "Clientes", icon: Users, id: "clientes" },
  { to: "/vehiculos", label: "Vehículos", icon: Car, id: "vehiculos" },
  { to: "/facturacion", label: "Facturación", icon: Receipt, id: "facturacion" },
  { to: "/ajustes", label: "Ajustes", icon: Settings, id: "ajustes" },
];
const ADMIN_NAV = { to: "/activaciones", label: "Activaciones", icon: ShieldCheck, id: "activaciones" };

export const Sidebar = ({ open, onClose }) => {
  const { workshopName, connected } = useOrders();
  const { session, signOut, profile } = useAuth();
  const items = profile?.es_admin === true ? [...NAV, ADMIN_NAV] : NAV;
  return (
    <>
      {open && <div className="fixed inset-0 z-30 bg-black/60 lg:hidden" onClick={onClose} />}
      <aside
        data-testid="sidebar"
        className={`fixed inset-y-0 left-0 z-40 flex h-[100dvh] w-64 flex-col overflow-y-auto border-r border-white/5 bg-[#0c0c0f] transition-transform duration-300 lg:sticky lg:top-0 lg:h-screen lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="flex shrink-0 items-center gap-3 px-6 py-6">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[var(--gold)] text-black">
            <Wrench className="h-5 w-5" strokeWidth={2.5} />
          </div>
          <div className="min-w-0">
            <p data-testid="sidebar-workshop-name" className="font-display truncate text-lg font-bold leading-none">{workshopName}</p>
            <p className="mt-1 text-[11px] uppercase tracking-[0.2em] text-zinc-500">Workshop OS</p>
          </div>
          <button data-testid="sidebar-close-btn" onClick={onClose} className="ml-auto text-zinc-500 lg:hidden"><X className="h-5 w-5" /></button>
        </div>
        <nav className="mt-4 flex shrink-0 flex-col gap-1 px-3">
          {items.map(({ to, label, icon: Icon, id }) => (
            <NavLink
              key={to} to={to} end onClick={onClose} data-testid={`nav-${id}`}
              className={({ isActive }) =>
                `group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors duration-200 ${isActive ? "bg-[var(--gold-soft)] text-[var(--gold)]" : "text-zinc-400 hover:bg-white/5 hover:text-zinc-100"}`}
            >
              <Icon className="h-[18px] w-[18px]" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto border-t border-white/5 px-6 py-5 text-xs text-zinc-500">
          <p data-testid="sidebar-user-email" className="mb-2 truncate text-zinc-300">{session?.user?.email}</p>
          <button data-testid="logout-btn" onClick={signOut} className="mb-4 flex items-center gap-2 text-zinc-400 transition-colors hover:text-[var(--gold)]">
            <LogOut className="h-4 w-4" /> Cerrar sesión
          </button>
          {connected === false ? "Sincronizando…" : "Sincronizado con Supabase"}
          <span data-testid="sidebar-sync-dot" className={`ml-2 inline-block h-2 w-2 rounded-full align-middle ${connected ? "bg-emerald-500" : "bg-zinc-500"}`} />
        </div>
      </aside>
    </>
  );
};
